module.exports = __webpack_public_path__ + "static/media/back_sprain.6329dd14.svg";